<form [formGroup]="form">
  <div style="display: flex; gap: 1rem">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ chickCostLabel }}</mat-label>
      <span matTextPrefix agrNumber class="spacing--padding-half-right">
        {{ currency | agrCurrencySymbol }}
      </span>
      <input
        matInput
        agrNumber
        [enableStepArrows]="false"
        [step]="0.0001"
        formControlName="chickCost"
        [placeholder]="chickCostLabel"
        data-test="cost-item__chick-cost"
        (change)="chickCostChange()"
      />
      <mat-error *ngIf="chickCostInvalid">
        {{ 'error-chick-price' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'total-price' | translate }}</mat-label>
      <span matTextPrefix agrNumber class="spacing--padding-half-right">
        {{ currency | agrCurrencySymbol }}
      </span>
      <input
        matInput
        agrNumber
        [enableStepArrows]="false"
        [step]="0.01"
        formControlName="chicksTotalCost"
        placeholder="{{ 'total-price' | translate }}"
        data-test="cost-item__chicks-total-cost"
        (change)="chickTotalCostChange()"
      />
      <mat-error *ngIf="chicksTotalCostInvalid">
        {{ 'error-total-price' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'total-price-including-vat' | translate }}</mat-label>
      <span matTextPrefix agrNumber class="spacing--padding-half-right">
        {{ currency | agrCurrencySymbol }}
      </span>
      <input
        matInput
        agrNumber
        [enableStepArrows]="false"
        [step]="0.01"
        formControlName="chicksTotalCostIncludingVat"
        placeholder="{{ 'total-price-including-vat' | translate }}"
        data-test="cost-item__chicks-total-cost-including-vat"
        (change)="chicksTotalCostIncludingVatChange()"
      />
    </mat-form-field>
  </div>
</form>
